import "intersection-observer";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import "./fonts/ss-glyphish-filled.css";
import "./fonts/ss-glyphish-outlined.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import {
	PublicClientApplication,
	AuthError,
	EventType,
} from "@azure/msal-browser";
import { msalConfig } from "./configs/msalConfig";
import ErrorBoundary from "./pages/ErrorBoundary";
import { logout } from "./services/authService";

const msalInstance = new PublicClientApplication(msalConfig);
const accounts = msalInstance.getAllAccounts();

msalInstance.addEventCallback((message) => {
	if (message.eventType === EventType.LOGIN_FAILURE) {
		if (message.error instanceof AuthError) {
			console.error("MSAL Login Error: ", message.error);
		}
	} else if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
		if (message.error instanceof AuthError) {
			console.error("MSAL Token Error: ", message.error);
		}
	} else if (message.eventType === EventType.LOGOUT_FAILURE) {
		if (message.error instanceof AuthError) {
			console.error("MSAL Logout Error: ", message.error);
		}
	} else if (message.eventType === EventType.SSO_SILENT_FAILURE) {
		if (message.error instanceof AuthError) {
			console.error("MSAL SSO Silent Error: ", message.error);
			logout(msalInstance, accounts[0]);
		}
	}
});

new Promise((resolve, reject) => {
	let renderErr = null;

	try {
		const reactComponentInstance = ReactDOM.render(
			<React.StrictMode>
				<ErrorBoundary>
					<Router>
						<MsalProvider instance={msalInstance}>
							<App />
						</MsalProvider>
					</Router>
				</ErrorBoundary>
			</React.StrictMode>,
			document.getElementById("root"),
			() => {
				setTimeout(() => {
					if (renderErr) {
						reject(renderErr);
					} else {
						resolve(reactComponentInstance);
					}
				});
			}
		);
	} catch (err) {
		renderErr = err;
		console.error("Error on first render, not caught in boundary: ", renderErr);
	}
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
